import '../eleve/eleve.scss';
import './professeurs.scss';
import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Table, Row, Col, Card, Avatar, Descriptions, Breadcrumb, Tag, Divider, Button, Spin, Tabs } from 'antd';
import { getProfesseur } from './personnel.reducer';
import { APP_DATE_FORMAT, APP_TIMESTAMP_FORMAT, AUTHORITIES } from 'app/config/constants';
import { TextFormat } from 'react-jhipster';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import OptionsProf from './options-personnel';
import { UserOutlined, DollarCircleOutlined, FieldTimeOutlined, TableOutlined } from '@ant-design/icons';
import QRCode from 'qrcode.react';
import { getEcole } from '../ecole/ecole.reducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getCalendarProf } from '../calendar/calendarEntry.reducer';
import { getEcoleActiveAnneeScolaire } from '../annee-scolaire/annee-scolaire.reducer';
import { faBookOpen, faCheck, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { getSalairesByProfesseurId } from '../salaire/salaire.reducer';
import { getPaymentMethodFromString } from 'app/utils/paymentUtils';
import ProfesseurCalendar from './ProfesseurCalendar';
export const PersonnelDetail = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const { TabPane } = Tabs;
  const anneeScolaire = useAppSelector(state => state.anneeScolaire.entityActive);

  useEffect(() => {
    dispatch(getProfesseur(props.match.params.id));
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getSalairesByProfesseurId(props.match.params.id));
    dispatch(getEcoleActiveAnneeScolaire(props.match.params.ecoleid));
  }, []);

  useEffect(() => {
    if (anneeScolaire?.id) {
      const entity = {
        professeurId: props.match.params.id,
        anneeScolaireId: anneeScolaire.id,
      };
      dispatch(getCalendarProf(entity));
    }
  }, [anneeScolaire?.id]);

  const professeurList = useAppSelector(state => state.professeur.entity);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const professeur = useAppSelector(state => state.professeur.entity);
  const isNotComptable = !useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.COMPTABLE]));
  const isSecretaire = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.SECRETAIRE]));
  const isNotSurveillantGeneral = !useAppSelector(state =>
    hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.SURVEILLANT_GENERAL])
  );
  const salaireByProfesseur = useAppSelector(state => state.salaire.entities);
  const loading = useAppSelector(state => state.salaire.loading);
  const moisListe = [
    'JANVIER',
    'FEVRIER',
    'MARS',
    'AVRIL',
    'MAI',
    'JUIN',
    'JUILLET',
    'AOUT',
    'SEPTEMBRE',
    'OCTOBRE',
    'NOVEMBRE',
    'DECEMBRE',
  ];

  const column = [
    {
      title: 'Pointages',
      key: 'type',
      dataIndex: 'type',
      render: type => (type === 'ENTREE' ? <Tag color="green">{type}</Tag> : <Tag color="red">{type}</Tag>),
    },
    {
      title: 'Date',
      key: 'date',
      dataIndex: 'date',
      render: date => <TextFormat type="date" value={date} format={APP_TIMESTAMP_FORMAT} />,
    },
  ];
  const dataMouvement = professeurList.pointages
    ?.map(pointage => ({
      type: pointage?.type,
      date: pointage?.date,
    }))
    .reverse();

  const columnSalaires = [
    {
      title: 'Salaire',
      dataIndex: 'mois',
      key: 'mois',
      render: (text, record) => (
        <Link to={!isSecretaire && `/salaires/${currentEcole.id}/${record.id}/details`}>
          <strong>{text}</strong>
        </Link>
      ),
      align: 'center' as const,
    },
    {
      title: 'Date Emission',
      dataIndex: 'dateEmission',
      key: 'dateEmission',
      align: 'center' as const,
      render: dateEmission => <TextFormat type="date" value={dateEmission} format={APP_DATE_FORMAT} />,
    },
    {
      title: 'Montant',
      dataIndex: 'montant',
      key: 'montant',
      align: 'center' as const,
    },
    {
      title: 'Date Paiement',
      dataIndex: 'datePaiement',
      key: 'datePaiement',
      align: 'center' as const,
      render: datePaiement => datePaiement && <TextFormat type="date" value={datePaiement} format={APP_DATE_FORMAT} />,
    },
    {
      title: 'Statut',
      dataIndex: 'statutSalaire',
      key: 'statutSalaire',
      align: 'center' as const,
      render: statutSalaire =>
        statutSalaire === 'EN_ATTENTE' ? (
          <Tag color="red">En attente</Tag>
        ) : statutSalaire === 'EMISE' ? (
          <Tag color="blue">Envoyée</Tag>
        ) : statutSalaire === 'PAYEE' ? (
          <Tag color="green">Payée</Tag>
        ) : statutSalaire === 'CREE' ? (
          <Tag color="#999">Crée</Tag>
        ) : (
          <Tag color="#999">{statutSalaire}</Tag>
        ),
    },
  ];

  const salairesData = salaireByProfesseur
    ?.map(salaire => ({
      id: salaire.id,
      key: salaire.numeroSalaire,
      statutSalaire: salaire.statutSalaire,
      dateEmission: salaire.dateEmission,
      datePaiement: salaire.datePaiement,
      montant: `${salaire.montant} ${'CFA'}`,
      mois: salaire.salaireGroup ? `${salaire.salaireGroup.mois} ${salaire.salaireGroup.annee}` : '',
    }))
    .reverse();

  const sortedData = salairesData?.sort((a, b) => {
    return moisListe.indexOf(a.mois.split(' ')[0]) - moisListe.indexOf(b.mois.split(' ')[0]);
  });
  const hasUserAccount = ['SECRETAIRE', 'DIRECTEUR', 'DIRECTEUR_ETUDE', 'SURVEILLANT', 'SURVEILLANT_GENERAL', 'CONTROLEUR_BUS'];
  const renderInfosProf = () => {
    return (
      <Card>
        {professeurList.id !== null && (
          <Row className="justify-content-center">
            <Col lg={{ span: 6 }} xs={{ span: 24 }} sm={{ span: 7 }} md={{ span: 6 }}>
              <Descriptions column={1} className="p-2">
                <Descriptions.Item>
                  <Avatar size={{ xs: 80, sm: 100, md: 100, lg: 120, xl: 150, xxl: 100 }} icon={<UserOutlined />} />
                </Descriptions.Item>
                <Descriptions.Item label="Statut">
                  {professeurList.statutPresence === 'PRESENT' ? (
                    <Tag color="green">{professeurList.statutPresence}</Tag>
                  ) : (
                    <Tag color="red">{professeurList.statutPresence}</Tag>
                  )}
                </Descriptions.Item>
                <Descriptions.Item>
                  {professeurList.support !== null ? <QRCode value={professeurList.support.qrcode} /> : <span className="qrcode"></span>}
                </Descriptions.Item>
              </Descriptions>
            </Col>
            <Divider type="vertical" style={{ height: 'auto' }} />
            <Col lg={{ span: 10 }} xs={{ span: 24 }} sm={{ span: 10 }} md={{ span: 10 }}>
              <h2 style={{ textAlign: 'center' }} className="p-3">
                {professeurList.prenom} {professeurList.nom}{' '}
              </h2>
              <span>
                <Descriptions column={1}>
                  {hasUserAccount.includes(professeurList.typePersonnel) && (
                    <>
                      <Descriptions.Item label="Login">{professeurList.login}</Descriptions.Item>
                      <Descriptions.Item label="Email">{professeurList.email}</Descriptions.Item>
                    </>
                  )}
                  <Descriptions.Item label="Matricule">{professeurList.matricule}</Descriptions.Item>
                  <Descriptions.Item label="Téléphone">{professeurList.telephone}</Descriptions.Item>
                  <Descriptions.Item label="Adresse">{professeurList.adresse}</Descriptions.Item>
                </Descriptions>
                <hr />
                <h5 style={{ textDecoration: '' }}>Informations administratives</h5>
                <Descriptions column={1}>
                  <Descriptions.Item label="Fonction">{professeurList.poste}</Descriptions.Item>
                  <Descriptions.Item label="Type de personnel">{professeurList.typePersonnel}</Descriptions.Item>
                  {professeurList.typePersonnel === 'ENSEIGNANT' && (
                    <>
                      <Descriptions.Item label="Classes">{professeurList.classes.map(c => c.nom).join(', ')}</Descriptions.Item>
                      <Descriptions.Item label="Matières">{professeurList.matieresEcole.map(m => m.nom).join(', ')}</Descriptions.Item>
                    </>
                  )}
                </Descriptions>
                {!isSecretaire &&
                  isNotSurveillantGeneral &&
                  (professeurList.salaireMensuel !== null || professeurList.tauxHoraire !== null) && (
                    <>
                      <hr />
                      <h5 style={{ textDecoration: '' }}>Informations Salariales</h5>
                      <Descriptions column={1}>
                        {professeurList.salaireMensuel !== null && (
                          <Descriptions.Item label="Salaire Mensuel">{professeurList.salaireMensuel} FCFA</Descriptions.Item>
                        )}
                        {professeurList.tauxHoraire !== null && (
                          <Descriptions.Item label="Taux Horaire">{professeurList.tauxHoraire} FCFA</Descriptions.Item>
                        )}
                        <Descriptions.Item label="Retenue BRS">
                          {professeurList.brs === true ? <Tag color="green">Activée</Tag> : <Tag color="red">Désactivée</Tag>}
                        </Descriptions.Item>
                        {(professeur.numeroTelephonePaiement !== null || professeur.numeroTelephonePaiement !== '') && (
                          <Descriptions.Item label="Numéro de Paiement">
                            {professeur.numeroTelephonePaiement}
                            &nbsp;
                            {professeur.validated === true ? (
                              <FontAwesomeIcon icon={faCheck} color="green" title="Numero vérifié" />
                            ) : (
                              <Link
                                to={`/personnel/${currentEcole && currentEcole.id}/${props.match.params.id}/verify-otp`}
                                id="jh-create-entity"
                                data-cy="entityCreateButton"
                              >
                                <FontAwesomeIcon icon={faExclamationCircle} color="red" title="Cliquer pour vérifier le numéro" />
                              </Link>
                            )}
                          </Descriptions.Item>
                        )}
                        <Descriptions.Item label="Préférence de Paiement">
                          {getPaymentMethodFromString(professeur.moyenPaiement)}
                        </Descriptions.Item>
                      </Descriptions>
                    </>
                  )}
              </span>
            </Col>

            <Divider type="vertical" style={{ height: 'auto' }} />
            <Col lg={{ span: 4 }} xs={{ span: 24 }} md={{ span: 6 }} sm={{ span: 5 }} style={{ textAlign: 'center' }}>
              {isNotComptable && isNotSurveillantGeneral && <OptionsProf {...props} />}

              {professeurList.typePersonnel === 'ENSEIGNANT' && (
                <>
                  <hr />
                  <h5>Historique Cours</h5>
                  <Button className="mb-2 mt-2" style={{ borderRadius: 16, textAlign: 'center', backgroundColor: 'green', color: 'white' }}>
                    <Link
                      to={`/personnel/${currentEcole.id}/${professeurList.id}/cours`}
                      id="jh-create-entity"
                      data-cy="entityCreateButton"
                    >
                      <FontAwesomeIcon icon={faBookOpen} />
                      &nbsp; &nbsp; Exécutés{' '}
                    </Link>
                  </Button>{' '}
                  &nbsp;
                  <Button style={{ borderRadius: 16, textAlign: 'center', backgroundColor: '#F28E19', color: 'white' }}>
                    <Link
                      to={`/personnel/${currentEcole.id}/${professeurList.id}/absences`}
                      id="jh-create-entity"
                      data-cy="entityCreateButton"
                    >
                      <FontAwesomeIcon icon={faBookOpen} />
                      &nbsp; Non Exécutés{' '}
                    </Link>
                  </Button>
                </>
              )}
            </Col>
          </Row>
        )}
      </Card>
    );
  };
  const renderPointagesProf = () => {
    return (
      <Card className="p-4">
        {' '}
        <h5 style={{ textAlign: 'center' }}>Historique Pointages</h5>
        <Table columns={column} dataSource={dataMouvement} bordered />
      </Card>
    );
  };

  const renderSalaireProf = () => {
    return (
      <Card>
        <h5 style={{ textAlign: 'center' }}>Historique Paiements Salariale</h5>
        <Spin spinning={loading} tip="Chargement...">
          {sortedData && sortedData.length > 0 ? (
            <Table columns={columnSalaires} dataSource={sortedData} bordered pagination={false} style={{ textAlign: 'center' }} />
          ) : (
            <div style={{ textAlign: 'center', padding: '20px' }}>Aucune historique de paiement trouvé.</div>
          )}
        </Spin>
      </Card>
    );
  };
  const renderTimeTable = () => {
    return <ProfesseurCalendar />;
  };
  return (
    <>
      <Breadcrumb className="p-2">
        <Breadcrumb.Item>
          <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/personnel/${currentEcole && currentEcole.id}`}>Personnel</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`personnel/${currentEcole && currentEcole.id}/${professeurList.id}/details`}>Details</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card>
        <Tabs defaultActiveKey="1">
          <TabPane
            tab={
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <UserOutlined />
                Informations
              </span>
            }
            key="1"
          >
            {renderInfosProf()}
          </TabPane>
          {professeurList.typePersonnel !== 'DIRECTEUR' && professeurList.typePersonnel !== 'DIRECTEUR_ETUDE' && (
            <>
              <TabPane
                tab={
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    <FieldTimeOutlined />
                    Pointages
                  </span>
                }
                key="2"
              >
                {renderPointagesProf()}
              </TabPane>

              {!isSecretaire && isNotSurveillantGeneral && (
                <TabPane
                  tab={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                      <DollarCircleOutlined />
                      Salaire
                    </span>
                  }
                  key="3"
                >
                  {renderSalaireProf()}
                </TabPane>
              )}

              {professeurList.typePersonnel === 'ENSEIGNANT' && (
                <TabPane
                  tab={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                      <TableOutlined />
                      Emploi du temps
                    </span>
                  }
                  key="4"
                >
                  {renderTimeTable()}
                </TabPane>
              )}
            </>
          )}
        </Tabs>
      </Card>
    </>
  );
};
export default PersonnelDetail;
